import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewChild, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent, InputComponent, InputErrorsComponent, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';
import { ValidationErrorType } from 'mbs-ui-kit/form/input-base/input-base.types';
import { convertToClientUrl } from 'mbs-ui-shared';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';

import { map, take } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'mbs-payment-modal',
  templateUrl: './payment-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonComponent,
    CommonModule,
    InputComponent,
    InputErrorsComponent,
    ModalComponent,
    ReactiveFormsModule,
    I18NextPipe,
    ModalFooterDirective
  ]
})
export class PaymentModalComponent {
  private auth = inject(AuthFacade);
  private baseHref = inject(APP_BASE_HREF);
  private i18pipe = inject(I18NextPipe);

  public get creditsCount() {
    return this.form.get('creditsCount').value;
  }

  public errors: Partial<ValidationErrorType>[] = [{ key: 'creditsCount', message: this.i18pipe.transform('shared:paymentModal.error') }];

  public form = new FormGroup({
    creditsCount: new FormControl(1, [Validators.min(1), Validators.required, Validators.pattern('^[0-9]*$')])
  });
  public userId = this.auth.currentUser$.pipe(map((user) => user.ProviderInfo.Id));

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  public getSubscribeUrl(userId: string): string {
    return `/Admin/payment.aspx?type=${this.auth.currentUserValue?.ProviderInfo?.CanBuyCreditsWithoutSubscription ? 'Credits' : 'Subscription'}&OwnerID=${userId}&customPrice=${this.creditsCount}&InvoiceID=`;
  }

  public redirectToPay(): void {
    this.userId.pipe(take(1), untilDestroyed(this)).subscribe((userId) => {
      location.href = convertToClientUrl(this.getSubscribeUrl(userId), this.baseHref);
    });
  }
}
